import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('@moawen-workspace/agency/feature-layout').then(
        (m) => m.agencyFeatureLayoutRoutes
      ),
  },
];
